export default "__VITE_ASSET__4de75366__"